import { mainPermissions } from "../../../util/MenuLinks";
import UserHavePermission from "../../../util/UserHavePermission";

const HnResponsiblesActions = ({ path }) => {

    return (
        <div className="d-flex align-items-center justify-content-end gap-2">
            {
                UserHavePermission(mainPermissions?.hnResponsibles?.[1]) &&
                <>
                    <a href={`/responsables/hn/importar`} className="btn btn-success">
                        Importar
                    </a>
                    <a href={`/responsables/hn/crear`} className="btn btn-primary">
                        Crear
                    </a>
                </>
            }

        </div>
    );
}

export default HnResponsiblesActions;